import { MasterServiceAgreementWidget } from '@/bundle/shared/components/MasterServiceAgreement/MasterServiceAgreementWidget';
import {
  AcceptMasterServiceAgreementForm,
  AcceptMasterServiceAgreementFormValuesType,
} from '@/bundle/Auth/AdminOnboardingFlow/AcceptMasterServiceAgreementPage/ui/AcceptMasterServiceAgreementForm';
import { formatReactStringToHTMLString } from '@/bundle/shared/components/MasterServiceAgreement/const';
import { useState } from 'react';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import { InternalOrganizationMasterServiceAgreementResponseType } from '@/api/v1/organization/internal/getInternalOrganizationMasterServiceAgreementApi';

type AcceptMasterServiceAgreementWidgetWrapperType = {
  agreementDocument: InternalOrganizationMasterServiceAgreementResponseType;
  modifiedDate: string;
  isLoading: boolean;
  onConfirm: (payload: AcceptMasterServiceAgreementFormValuesType) => void;
};

export const AcceptMasterServiceAgreementWidgetWrapper = ({
  agreementDocument,
  modifiedDate,
  isLoading,
  onConfirm,
}: AcceptMasterServiceAgreementWidgetWrapperType) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const { observerTarget } = useIntersectionObserver<HTMLSpanElement>(() => setIsDisabled(false));

  const { agreement_html } = agreementDocument;

  return (
    <MasterServiceAgreementWidget
      header='Master Service Agreement'
      modifiedDate={modifiedDate}
      actionSlot={
        <AcceptMasterServiceAgreementForm isDisabled={isDisabled} isLoading={isLoading} onConfirm={onConfirm} />
      }
    >
      <div dangerouslySetInnerHTML={{ __html: formatReactStringToHTMLString(agreement_html) }} />
      <span ref={observerTarget} />
    </MasterServiceAgreementWidget>
  );
};
